export default "__VITE_ASSET__BebBis_w__"